module.exports = __webpack_public_path__ + "media/images/svg/quotes-0006409c697ec545ccf44fd2791a8699.svg";